module.exports = __webpack_public_path__ + "img/shequ1.f8a804e1.png";